import type { EntityType } from './types';

export const TEMP_ID_PREFIX = 'offline_';

export const ENTITY_TABLES: EntityType[] = [
  'clients',
  'bookings',
  'tasks',
  'leads',
  'measurements',
  'packages',
  'challenges',
  'trainingPlans',
];

export const COMPOSITE_KEYS = {
  trainerProfile: 'trainerProfile',
  analyticsRetention: 'analytics:retention',
  analyticsFunnel: 'analytics:funnel',
  clientCoins: (clientId: string) => `clientCoins:${clientId}`,
  trainingPlanDetail: (id: string) => `trainingPlanDetail:${id}`,
} as const;
